import { useMutation, useQueryClient } from '@tanstack/react-query';

import PromptsService, { Prompt } from '@/services/PromptsService';

export function useSetPromptAsMain() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (id: string) => {
      const result = await PromptsService.setAsMain(id);
      return result;
    },

    onMutate: async (id: string) => {
      await queryClient.cancelQueries({ queryKey: ['prompts'] });

      const previousPrompts = queryClient.getQueryData(['prompts']);

      queryClient.setQueryData(['prompts'], (old: any) => {
        if (!old?.pages) return old;

        return {
          ...old,
          pages: old.pages.map((page: any) => {
            return {
              ...page,
              items: page.items.map((prompt: Prompt) => ({
                ...prompt,
                isMain: prompt.id === id,
              })),
            };
          }),
        };
      });

      return { previousPrompts };
    },

    onError: (_, __, context) => {
      if (context?.previousPrompts) {
        queryClient.setQueryData(['prompts'], context.previousPrompts);
      }
    },

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['prompts'],
      });
    },
  });

  return {
    setPromptAsMain: mutateAsync,
    isSettingAsMain: isPending,
  };
}
